// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-detail__container {
    margin: 0 100px;
    position: relative;
}

.tournament-detail__tournament-data {
    position: relative;
}

.tournament-detail__title{
    margin-bottom: 38px;
    display: flex;
    align-items: center;
}
.tournament-detail__title.baloa-subtitle-2{
    color: var(--primary-dark-color);
}
.tournament-detail__title .icon-arrow-left{
    padding-right: 16px;
    font-size: 23px;
    color: var(--black-color);
    cursor: pointer;
}
.tournament-detail__image{
    border-radius: 16px 16px 0px 0px;
    background: rgba(77, 84, 81, 0.64);
    backdrop-filter: blur(4px);  
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}
.tournament-detail__image .icon-trophy{
    color: var(--white-color);
    font-size: 52px;
    width: 419px;
    height: 229px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tournament-detail__image img{
    width: 419px;
    height: 229px;
}
.tournament-detail__image__tags{
    position: absolute;
    display: flex;
    bottom: 15px;
    left: 16px;
    gap: var(--space-half);
}
.tournament-detail__image__tags-tag{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--white-color);
    background: rgba(0, 0, 0, 0.61);
    border-radius: 32px;
    padding: 5px 8px;
}
.tournament-detail__data{
    padding: 13px 8px 15px 8px;
    display: flex;
    align-items: center;
    background: var(--white-color);
    justify-content: space-between;
}
.tournament-detail__data__info{
    display: flex;
    align-items: center;
}
.tournament-detail__data__info .icon-ball{
    color: var(--white-color);
    font-size: 33px;
    padding: 5px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-detail__data__info img{
    width: 43px;
    height: 43px;
    border-radius: 50%;
}
.tournament-detail__data__info.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
}

.tournament-detail__data__button.small{
    padding: 10px 20px;
    margin-right: 10px;
}

.tournament-detail__tabs {
    background: var(--white-color);
    border-top: 1px solid var(--new-gray-background-color);
}

.tournament-detail__tabs .MuiTab-wrapper {
    text-transform: none;
    /* New_Table Column Names */
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);/* 15px */
    line-height: calc(var(--space) + var(--space-eighth));/* 18px*/;
    letter-spacing: 0.0025em;
    color: var( --basic-gray-color );
}

.tournament-detail__tabs .MuiTab-root.Mui-selected *{
    display: flex;
    align-items: center;
    text-align: center;
    color: var( --primary-dark-color );   

}

.tournament-detail__tabs .MuiTab-root:hover .MuiTab-wrapper {
    color: var( --primary-dark-color );
}

.tournament-detail__tabs__button{
    position: absolute;
    display: flex;
    bottom: 15px;
    right: 16px;
}
.tournament-detail__tabs__button .secondary-button{
    padding-left: 13px;
    color: var(--primary-dark-color);
}
.tournament-detail__tabs__button.small{
    padding: 10px;
    color: var(--primary-dark-color);    
}

/* .tournament-detail__tabs__button.small span{
    grid-area: unset;
} */

.tournament-detail__tabs__button .icon-share{
    grid-area: icon;
    padding-right: 13px;
    color: var(--new-green-color);
    font-size: 20px;
}

.tournament-detail__tabs__button.small:hover{
    color: var(--white-color);   
}

.tournament-detail__tabs__button.small:hover .icon-share{
    color: var(--white-color);   
}
.tournament-detail__tournament-teams{
    margin-top: 14px;
    padding: 27px 30px;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    border-radius: 14px;
}

.tournament-detail__tournament-teams .baloa-names {
    color: var(--new-green-color);
    text-align: center;
    cursor: pointer;
}

.tournament-detail__tournament-teams__title.baloa-subtitle-2{
    color: var(--primary-dark-color); 
    padding-bottom: 14px;
}
.tournament-detail__tournament-team{
    display: flex;
    padding: 12px 0;

}

.tournament-detail__tournament-team:hover{
    cursor: pointer;
}

.tournament-detail__tournament-team__image{
    width: 39px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tournament-detail__tournament-team__image img{
    width: 39px;
    height: 39px;
    border-radius: 50%;
}

.tournament-detail__tournament-team__image .icon-ball{
    color: var(--white-color);
    font-size: 29px;
    padding: 5px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-detail__tournament-team__data{
    padding-left: 9px;
}

.tournament-detail__tournament-team__data .baloa-names, .tournament-detail__tournament-team__data .baloa-username{
    color: var(--primary-dark-color);
    text-align: left;
}

.tournament-detail__selected-team{
    background: var(--white-color);
    border-radius: 14px;
    display: flex;
    align-items: center;
    padding: 12px 27px;
    margin-top: 14px;

    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.0025em;
}

.tournament-detail__selected-team img{
    border-radius: 50%;
    width: 38px;
    height: 38px;
    margin-right: 27px;
}

.tournament-detail__selected-team .icon-ball{
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 27px;
}

.tournament-detail__team-info {
    display: flex;
    align-items: center;
    background-color: var(--white-color);
    margin-top: var(--space);
    border-radius: var(--space);
    margin-right: auto;
}

.tournament-detail__team-info .hubicon-info {
    font-size: 20px;
    border-radius: 50%;
    background-color: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-detail__team-info .baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-left: 10px;
}

.tournament-detail__team-players__team,
.tournament-detail__team-players__players .player-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-detail__team-players__players {
    max-height: 314px;
}

.tournament-detail__team-players__team .left-col,
.tournament-detail__team-players__players .player-container .left-col {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    
}

.tournament-detail__team-players__team .left-col .icon-ball,
.tournament-detail__team-players__players .player-container .left-col .icon-ball {
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    margin-right: var(--space-half);
}

.tournament-detail__team-container {
    position: relative;
}

.tournament-detail__team-players__team .left-col img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    margin-right: var(--space-half);
}

.tournament-detail__team-players__team .name-username .baloa-names,
.tournament-detail__team-players__players .player-container .name-username .baloa-names {
    white-space: nowrap;
    color: var(--primary-very-dark-color);
}

.tournament-detail__team-players__players .player-container .name-username .baloa-names {
    margin-bottom: var(--space-quarter);
    display: flex;
    align-items: center;
    gap: 4px;
}

.tournament-detail__team-players__team .name-username .baloa-username,
.tournament-detail__team-players__players .player-container .name-username .baloa-username {
    white-space: nowrap;
    color: var(--primary-dark-color);
    margin-top: var(--space-eighth);
}
/* juagdores */
.tournament-detail__team-players {  
    padding: var(--space-and-half);
    background-color: var(--white-color);
    border-radius: var(--space);
    margin-top: var(--space);
    margin-bottom: var(--space);
}

.tournament-detail__team-players__players .player-container .right-col {
    display: flex;
    justify-content: flex-start;
    width: 20%;
}

.tournament-detail__team-players__team .right-col .baloa-username,
.tournament-detail__team-players__players .player-container .right-col .baloa-username,
.tournament-detail__team-inscription-column__status.baloa-username {
    padding: var(--space-quarter) var(--space-half);
    border-radius: var(--space-and-half);
    background-color: var(--basic-gray-color);
    color: var(--white-color) !important;
    width: fit-content;
}

.tournament-detail__team-players__team .right-col .baloa-username.enrolled,
.tournament-detail__team-players__players .player-container .right-col .baloa-username.enrolled, 
.tournament-detail__team-inscription-column__status.baloa-username.enrolled{
    background-color: var(--new-green-color);
}

.tournament-detail__team-players__players .player-container .right-col .baloa-username.rejected,
.tournament-detail__team-inscription-column__status.baloa-username.rejected {
    background-color: var(--error-color);
}

.tournament-detail__team-players__players .player-container .right-col .baloa-username.register,
.tournament-detail__team-inscription-column__status.baloa-username.register {
    background-color: var(--new-yellow-color);
}

.players-title.baloa-table-column {
    color: var(--primary-dark-color);
    margin: var(--space-and-half) 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-detail__players-title.baloa-hyperlink {
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-and-half);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-detail__players__bottons{
    display: flex;
    align-items: center;
}

.tournament-detail__players__bottons-margin{
    margin-right: var(--space);
}

.tournament-detail__team-players__players .left-col img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    margin-right: var(--space-half);
}

.tournament-detail__team-rejected-msg {
    display: flex;
    align-items: center;
    background-color: var(--white-color);
    border-radius: var(--space);
    margin-top: var(--space);
}

.tournament-detail__team-rejected-msg span {
    font-size: var(--space);
    background-color: var(--error-color);
    color: var(--white-color);
    border-radius: 50%;
    margin-right: var(--space);
}

.tournament-detail__team-rejected-msg .baloa-table-column {
    color: var(--primary-very-dark-color);
}

.enrolled-players.baloa-username {
    color: var(--basic-gray-color);
    margin-bottom: var(--space-and-half);
}

.tournament-detail__player-code {
    position: absolute;
    top: 0px;
    right: 0px;
    background: var(--white-color);
    border-radius: 14px;
    padding: 16px;
    width: 28%;
    margin-left: 14px;
}

.tournament-detail__player-code.move-top {
    top: 64px;
}

.tournament-detail__player-code .baloa-normal-medium {
    color: var(--primary-dark-color);
}
.tournament-detail__player-code .baloa-normal-medium img {
    padding-left: 8px;
}

.tournament-detail__player-code__code {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color);
    padding: 10px 0;
    text-align: center;
    cursor: pointer;
    background-color: var(--new-background-color);
    margin-top: 16px;
}
.tournament-detail__player-code__code .icon-copy-86{
    font-size: 20px;
    color: var(--primary-dark-color);
}

/* .tournament-detail__team-players__players.scroll {
    padding-right: var( --space-half );
} */

.tournament-detail__team-players__team .right-col {
    margin-right: var( --space-and-half );
}

.tournament-detail__team-inscription{
    display: flex;
    align-items: center;
    /* justify-content: space-evenly; */
    flex-wrap: wrap;
    background: var(--white-color);
    padding: 12px 16px;
    border-radius: 16px;
    width: 70%;
    margin-top: 12px;
}

.tournament-detail__team-inscription__data{
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
    width: 100%;
    border: 1px solid var(--new-line-color);
    border-radius: 16px;
    margin-top: 16px;
}

.tournament-detail__team-inscription-column:first-child{
    width: 40%;
}

.tournament-detail__team-inscription-column{
    width: 20%;
}

.tournament-detail__team-inscription-column__title.first-column{
    border-top-left-radius: 16px;
}

.tournament-detail__team-inscription-column__title.last-column{
    border-top-right-radius: 16px;
}

.tournament-detail__team-inscription-column__title.baloa-table-column{
    color: var(--primary-very-dark-color);
    background-color: var(--new-background-color);
    padding: 12px 0 12px 16px;
}

.tournament-detail__team-inscription-column__state.baloa-username{
    color: var(--basic-gray-color);
    display: flex;
    padding: 24px 16px;
}

.green-bullet{
    color: var(--new-green-color);
    font-size: 50px;
}
.green-bullet.color{
    color: var(--error-color);
}

.tournament-detail__team-inscription-column__button{
    border: 2px solid var(--new-green-color);
    background: var(--white-color);
    padding: 8px 16px;
    margin: 16px;
}

.tournament-detail__team-inscription-column__button-player{
    border: 2px solid var(--new-gray-color);
    background: var(--white-color);
    padding: 8px 16px;
    margin: 16px 0;
}

.tournament-detail__team-inscription-column__button.baloa-username{
    color: var(--new-green-color);
    font-weight: var(--font-medium);
}

.tournament-detail__team-inscription-column__button.baloa-username:disabled {
    color: var(--new-green-color);
    border-color: var(--new-green-color);
    opacity: 0.6;    
}

.tournament-detail__team-inscription__title.baloa-hyperlink{
    color: var(--primary-very-dark-color);
    width: 100%;
    padding: 16px 0;
}

.tournament-detail__team-inscription-column__team-info{
    display: flex;
    align-items: center;
    padding: 12px;
}

.tournament-detail__team-inscription-column__team-info__name-username{
    margin-left: 10px;
}

.tournament-detail__team-inscription-column__team-info__name-username .baloa-names  {
    color: var(--primary-very-dark-color);
}

.tournament-detail__team-inscription-column__team-info__name-username .baloa-username{
    color: var(--primary-dark-color);
}

.tournament-detail__team-inscription-column__team-info img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.tournament-detail__team-inscription-column__team-info .icon-ball{
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-detail__team-inscription-column__status{
    margin: 24px 16px;
    white-space: nowrap;
}

.tournament-detail__team-inscription-column__status.team-widget{
    margin: 0 16px;
}


.tournament-detail__player-inscription{
    display: flex;
    width: 100%;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.tournament-detail__player-inscription-column__title.baloa-table-column{
    color: var(--primary-very-dark-color);
    background-color: var(--new-background-color);
    padding: 12px 0 12px 16px;
}

.tournament-detail__player-inscription-column__title:first-child{
    width: 33%;
    border-top-left-radius: 16px;
}

.tournament-detail__player-inscription-column__title:last-child{
    border-top-right-radius: 16px;
}

.tournament-detail__player-inscription-column__title{
    width: 22%;
}

.tournament-detail__player-inscription-column{
    width: 22%;
    display: flex;
    align-items: center;
    padding: 0 0 0 16px;
}

.staff__roll{
    justify-content: center;
}

.tournament-detail__player-inscription-column:first-child{
    width: 34%;
}

.tournament-detail__player-inscription-column .baloa-username{
    align-items: center;
    display: flex;
    color: var(--primary-dark-color);
}

.tournament-detail__player-inscription-column .baloa-username.disabled {
    color: var(--primary-color);
}

.tournament-detail__player-inscription-column img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    margin-right: 12px;
}

.tournament-detail__player-inscription-column .icon-ball{
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
}
.margin_form{
    margin-top: var(--space-and-half);
    margin-bottom: var(--space);
}

.tournament-detail__player-code__quantity.baloa-username{
    padding-top: 12px;
    color: var(--basic-gray-color);
    font-weight: bold;
}

.tournament-detail__player-code__quantity-text{
    font-weight: normal;
}
.tournament-detail__image__background-img_container {
    position: absolute;
    width: 100%;
    height: 229px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px 16px 0px 0px;
}

.tournament-detail__image__background-img {
    width: 100%;
}

.tournament-detail__team-inscription .secondary-button {
    border: var( --space-eighth ) solid var( --error-color );
    color: var( --error-color );
    margin-top: 16px;
}

.tournament-detail__team-inscription .secondary-button:hover {
    border: var( --space-eighth ) solid var( --error-color );
    color: var( --white-color );
    background-color: var(--error-color);
}

.tournament-detail__team-inscription .secondary-button:focus {
    border: var( --space-eighth ) solid var( --error-color );
    color: var( --white-color );
    background-color: var(--error-color);
}

.tournament-detail__team-inscription_mobile{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    background: var(--white-color);
    padding: 12px 12px;
    border-radius: 16px;
    width: 100%;
    margin-top: 12px;
}

.tournament-detail__team-inscription-team_inf{
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.tournament-detail__player-inscription-row_mobile{
    display: flex;
    justify-content: space-between;
    width:85%;
}

.tournament-detail__player-inscription-buttons_mobile{
    display: flex;
    justify-content: space-between;
}

.tournament-detail__player-inscription-buttons_text_mobile{
    margin-right: var(--space-x2);
}

.tournament-detail__player-inscription-buttons_text_mobile .baloa-username{
    display: flex;
}

.tournament-detail__team-inscription_buttons_form{
    display: flex;
    justify-content: space-between;
    width: 70%;
}

.tournament-detail__player-code_mobile {
    background: var(--white-color);
    border-radius: 14px;
    padding: 16px;
    margin: var(--space) 0;
}

.tournament-detail_search_player-form {
    display: flex;
    align-items: center;
    padding-bottom: var(--space);
}

.tournament-detail_search_player-form span.icon-search {
    position: absolute;
    font-size: calc( var( --space ) + var( --space-quarter ) );
    color: #949F9A;
    margin-left: calc( var( --space ) - var( --space-eighth ) );
}

.tournament-detail_search_input {
    min-width: calc(var(--space-x3) * 8);
    border: none;
    min-height: var( --space-x2 );
    border-radius: calc( var( --space-and-half ) - var( --space-eighth ) );
    background: var( --new-gray-background-color );
    padding-left: var( --space-x3 );
}

.tournament-detail__team-players_mobile{
    padding: var(--space-and-half);
    background-color: var(--white-color);
    border-radius: var(--space);
    margin-top: var(--space);
    margin-bottom: var(--space-x3);
}

.tournament-detail__team-container .tournament-detail__team-players .tournament-detail__teams-filter {
    margin-bottom: var(--space);
    margin-top: var(--space);
}

.tournament-detail__team-container .tournament-detail__team-players_mobile .tournament-detail__teams-filter {
    margin-bottom: var(--space);
}

.tournament-detail__team-players__share-button .hubicon-person_add {
    grid-area: icon;
    margin-right: 13px;
    font-size: 24px;
}

.secondary-button.tournament-detail__team-players__share-button{
    padding: 10px 20px;
}

.tournament-detail__data__button span.hubicon-manage_accounts1 {
    grid-area: icon;
    /* color: var(--primary-very-dark-color);
    font-size: 20px; */
    justify-self: end;
    margin-right: 4px;
}

.tournament-detail__data_buttons{
    display: flex;
    gap: var(--space); 
}

.tournament-detail_data_buttons_icons{
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 10px;
}

.tournament-detail__staff {  
    padding: var(--space-and-half);
    background-color: var(--white-color);
    border-radius: var(--space);
    margin-top: var(--space);
    margin-bottom: var(--space-x3);
}

.tournament-detail__staff-title{
    margin-bottom: var(--space);
}

.tournament-detail__staff-inscription{
    display: flex;
    width: 100%;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.tournament-detail__staff-inscription-column__title.baloa-table-column {
    color: var(--primary-very-dark-color);
    background-color: var(--new-background-color);
    padding: 12px 0 12px 16px;
}

.tournament-detail__staff-inscription-column__title:first-child{
    width: 33%;
    border-top-left-radius: 16px;
}

.tournament-detail__staff-inscription-column__title:last-child{
    border-top-right-radius: 16px;
}

.tournament-detail__staff-inscription-column__title{
    width: 22%;
}
.tournament-detail__staff-inscription-column__title__width{
    width: 11%;
}

/**Mobile**/
.tournament-detail__team-inscription-column-mobile:first-child{
    width: 70%;
}
.tournament-detail__team-inscription-column-mobile{
    width: 30%;
}
.tournament-detail__team-inscription_buttons_form .tournament-detail__team-inscription-column-mobile{
    width: 50%;
    padding: 0 12px;
}

.tournament-detail__team-inscription-column__button-mobile.baloa-username{
    border: 2px solid var(--new-green-color);
    background: var(--white-color);
    padding: 8px 16px;
    margin: 12px 0;
}

.tournament-detail__no-dates-phases__container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 100px;
}

.tournament-detail__container .league-tournament-report-dates__tabs,
.tournament-detail__phases__list {
    background-color: var(--white-color);
}

.tournament-detail__phases__list .MuiFormControl-root {
    min-width: 350px;
    margin: 16px 16px 24px 16px;
    border: 1px solid var(--new-gray-color);
    padding: var(--space-half-quarter);
    border-radius: var(--space-quarter);
}

.tournament-detail__phases__list .MuiInputBase-root {
    font-family: var(--secondary-font);
    font-weight: var(--font-medium);
    font-size: 19px;
    line-height: 22px;
}

.tournament-detail__phases__list .MuiInput-underline:before, 
.tournament-detail__phases__list .MuiInput-underline:hover:not(.Mui-disabled):before,
.league-tournament-report-calendar__tabs_border .MuiTabs-flexContainer {
    border-bottom: none;
}

.tournament-detail__responsive__inscription-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--space);
    z-index: 100;
}

.tournament-detail__responsive__inscription-btn .tournament-detail__data__button.small {
    margin: 0px;
    padding: none;
    width: 100%;
}

.tournament-hub__loader-mobile {
    height: 100vh;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.tournament-hub__loader-mobile img {
    width: 40%;
}

.league-tournament-report-tab-options_iframe{
    display: flex;
    justify-content: space-between;
    background-color: var(--white-color);
    align-items: center;
    padding-right: var(--space);
}

.tournament-detail__tournament-podium{
    margin: var(--space-x2) 0;
}

.tournament-detail__players-title{
    display: flex;
    align-items: flex-end;
    position: relative;
    cursor: pointer;
}

.tournament-detail__players__button-options__box{
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    width: 300px;
    right: 0;
    top: 50px;
    display: none;   
    border-radius: var(--space-half); 
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space-half);
}

.tournament-detail__players__button-options__box.active{
    display: block;
    z-index: 1;
}

.tournament-detail__button-options__box__box-option {
    cursor: pointer;
    border-radius: 8px;
    padding: var(--space-half);
}
.tournament-detail__button-options__box__box-option:hover {
    background-color: var(--new-background-color);
}

.tournament-detail__button-options__box__box-option .baloa-names,
.tournament-detail__button-options__box__box-option .baloa-username {
    color: var(--primary-very-dark-color);
}

.tournament-detail__unlocked__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    padding: 8px;
    gap: 8px;
    background: var(--white-color);
    margin-top: 12px;
}

.tournament-detail__unlocked__team-info {
    display: flex;
    align-items: center;
    background-color: var(--white-color);    
}

.tournament-detail__unlocked__team-info .hubicon-info:before {
    font-size: 20px;
    color: var(--new-informative-banner-color);
}

.tournament-detail__unlocked__team-info .hubicon-award_star {
    font-size: 20px;
}

.tournament-detail__unlocked__team-info .baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-left: 10px;
}

.tournament-detail__unlocked__info .button.small{
    padding: 8px 12px;
}

.league-tournament-report-calendar__tabs_border{
    border-bottom: 2px solid var(--border-card-color);
    background-color: white;
}

.league-tournament-report-calendar__tabs_border .PrivateTabIndicator-colorPrimary-2, .league-tournament-report-calendar__tabs .MuiTab-wrapper{
    background-color: white; 
}

.league-tournament-report-calendar__tabs{
    background-color: white;
    border-bottom: none;
}

.league-tournament-report-calendar__tab{
   padding-bottom: 12px;
}

.league-tournament-report-calendar__tab .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary {
    border: 1px solid var(--basic-gray-color);
    border-radius: 25px;
    background: var(--white-color);
    padding: 6px 12px;
    min-height: unset;
    margin: 0 5px;
}

.league-tournament-report-calendar__tab .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected {
    border: 1px solid var(--new-green-color);
    background: #EAF7F0;
}

.league-tournament-report-calendar__tabs .Mui-selected .MuiTab-wrapper,.league-tournament-report-calendar__tabs_border .Mui-selected .MuiTab-wrapper {
    border: 2px solid var(--new-green-color);
    background-color: #EAF7F0;
}

.tournament-detail__team-players__players-skeleton {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 12px 16px;
}

.tournament-detail__team-players__players-skeleton__text {
    margin-left: 10px;
}

.tournament-detail__team-players__players-skeleton__last-text {
    align-items: center;
    margin-left: auto;
    margin-right: 12%;
}

.tournament-detail__team-players__players__view-more-link.baloa-names {
    color: var(--new-green-color);
    text-align: center;
    cursor: pointer;
    position: sticky;
    bottom: -1px;
    background: var(--white-color);
}

.tournament-detail__team-players__players__empty-msg.baloa-names {
    padding: 80px 0;
    text-align: center;
    color: var(--basic-gray-color);
}

.tournament-detail__teams-filter {
    display: flex;
    align-items: center;
}

.tournament-detail__teams-filter .filter-label.baloa-table-column {
    color: var( --primary-dark-color );
    margin-right: var( --space-half );
    padding: var( --space-half ) var( --space );
    border-radius: var( --space-and-half );
    border: 1px solid var( --primary-dark-color );
    cursor: pointer;
}

.tournament-detail__teams-filter .filter-label.baloa-table-column.selected-state {
    color: var( --new-green-color );
    background-color: #EAF7F0;
    border: 1px solid var( --new-green-color );
}

.tournament-detail__staff-info-inscription-column:first-child{
    width: 70%;
}

.tournament-detail__staff-info-inscription-column{
    width: 30%;
}

.tournament-detail__staff-info-inscription-column__title.first-column{
    border-top-left-radius: 16px;
}

.tournament-detail__staff-info-inscription-column__title.last-column{
    border-top-right-radius: 16px;
}

.tournament-detail__staff-info-inscription-column__title.baloa-table-column{
    color: var(--primary-very-dark-color);
    background-color: var(--new-background-color);
    padding: 12px 0 12px 16px;
}

.tournament-detail__staff-info-inscription-column__state.baloa-username {
    color: var(--basic-gray-color);
    display: flex;
    padding: 24px 16px;
}

#menu-teamname .MuiPaper-root.MuiPopover-paper.MuiMenu-paper {
    top: 10px !important;
}

.tournament-detail__tabs__puntuation__container {
    background: var(--white-color);
    padding: 20px;
}

.tournament-detail__payment-message__container {
    background: var(--white-color);
    border-radius: 8px;
    padding: 8px;
    margin-top: 12px;
}

.tournament-detail__payment-message {
    background: var(--new-informative-banner-bg-color);
    border-radius: 8px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
}

.tournament-detail__payment-message .button {
    padding: 8px 12px;
}

.tournament-detail__payment-message .button span {
    white-space: nowrap;
}

.tournament-detail__payment-message__data .baloa-names {
    font-size: calc(var(--space) + 2px);
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    margin-top: 8px;
}

.tournament-detail__payment-message__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
}

.tournament-detail__payment-message__title .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.tournament-detail__payment-message__title .hubicon-info::before {
    font-size: 21px;
    color: var(--new-informative-banner-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .tournament-detail__container{
        margin: 0;
        padding-bottom: 50px;
    }
    .tournament-detail__title.baloa-subtitle-2 {
        margin: 0 0 20px 16px;
    }
    .tournament-detail__image img{
        border-radius: 5px 5px 0 0;
        width: 100%;
        height: 205px;
        
    }
    .tournament-detail__image__tags{
        /* font-size: 10px; */
        width: 42px;
        height: 12px;
        
    }
    .tournament-detail__image__tags-tag{
        font-size: 10px;
        top:4px;
        line-height: 12px;
        white-space: nowrap;
        margin-right: 5px;
        
    }
    .tournament-detail__data{
        display: block;
        background: var(--white-color);
    }
    .tournament-detail__data__info img{
        width: 28px;
        height: 28px;
        left: 12px;
        top:12px;
        border-radius: 50%;
    }
    .tournament-detail__data__info.baloa-subtitle-2{
        font-size: 15px;
        white-space: nowrap;
    }
    .tournament-detail__data__button.small{
        padding: 8px 12px;
        margin-right: 0;
        
    }
    .tournament-detail__data__button span{
       font-size: 12px;
    }
    .tournament-detail__tabs.MuiTabs-root{
        border-top: none;
        min-height: 28px;
    }

    .tournament-detail__tabs .MuiTabs-indicator {
        bottom: auto ;
        width: 63px;
        height: 4px;
        border-radius: 4px 4px 0px 0px;  
    }

    .tournament-detail__container .MuiTabs-flexContainer {
        display: block;
        border-bottom:0;            
    }

    .tournament-detail__tabs .MuiTab-fullWidth{
        white-space: nowrap;
        padding: var(--space-quarter) var(--space);
        min-height: 0;
        font-family: var(--secondary-font);
    }

    .tournament-information span{
        color:var(--basic-gray-color);
    }

    .tournament-detail__team-players__team, .tournament-detail__team-players__players .player-container{
        flex-direction: column;
        align-items: flex-start;
        padding-bottom: 10px;
        padding-top: 10px;
        border-bottom: 0.5px solid #E7E7E7;
    }

    .tournament-detail__player-inscription-column,
    .tournament-detail__team-inscription__title.baloa-hyperlink 
    /* .tournament-detail__team-inscription-column__team-info */{
        padding: 0px;
    }

    .tournament-detail__team-inscription-column__button-player,
    .tournament-detail__data_share_mobile .tournament-detail__tabs__button{
        margin: 0px;
    }

    .tournament-detail__player-inscription-row_mobile .tournament-detail__player-inscription-column .tournament-detail__team-inscription-column__status{
        margin: 14px;
        white-space: nowrap;

    }

    .tournament-detail__team-inscription__data{
        border: none;
        border-radius:0px;
        flex-direction: column;
        margin-top: 0;
        border: 1px solid var(--new-line-color);
        border-radius: 16px;
        margin-top: 12px;
    }

    .tournament-detail__team-inscription-column{
        width: auto;
    }

    .tournament-detail__team-inscription-column__state.baloa-username{
        padding: 16px 0;
    }

    .tournament-detail_search_input.baloa-names{
        font-weight: var(--font-regular);
        font-size: 13px;
        color:var(--basic-gray-color);
    }

    .tournament-detail__team-players_mobile .tournament-detail__team-players__players .player-container{
        flex-direction: row;
    }

    .tournament-detail__team-inscription-column__title.baloa-table-column{
        background-color: var(--new-background-color);
    }

    .tournament-detail__data_share_mobile{
        display: flex;
        justify-content: space-between;
        margin-top: var(--space);
    }

    .tournament-detail__data_share_mobile .hubicon-share {
        font-size: var(--space-x2);
        margin-right: var(--space);
    }    
    .tournament-detail_search_input {
        min-width: unset;
        width: 100%;
    }
    
    .players-title.baloa-table-column{
        display: block;
        margin-top:0;
        color: var(--primary-very-dark-color);
    }

    .primary-button.tournament-detail__team-players__share-button{
        margin-top: var(--space);
        width: 100%;
        justify-content: center;
    }

    .tournament-detail__team-players__share-button .icon {
        grid-area: icon;
    }

    .tournament-detail__team-players__share-button .hubicon-share_v2{
        color: var(--white-color);
    }

    .tournament-detail__player-inscription-buttons_text_mobile,
    .tournament-detail__player-inscription-buttons_text_mobile .baloa-name{
        margin-top: var(--space);
    }

    .tournament-detail__player-inscription-buttons_text_mobile .baloa-username{
        margin-top: var(--space-half);
        padding-top: var(--space-half);
    }

    .tournament-detail__team-players {
        padding-top: var(--space-and-half);
    }
    .tournament-detail__team-inscription-column__team-info .icon-ball{
        color: var(--white-color);
        font-size: 24px;
        padding: 2px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tournament-detail__team-inscription-column__team-info img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
    }

    .tournament-detail__data_buttons {
        gap: 0;
        justify-content: center;
        margin-top: var(--space-and-half);
    }

    .tournament-detail__phases__list .MuiFormControl-root {
        min-width: 100%;
        margin: 0;
        
    }

    .tournament-detail__phases__list {
        padding: var(--space);
    }

    .tournament-detail__phases__list .MuiInputBase-root {
        font-size: var(--space);
        line-height: var(--space-and-half);
    }

    .tournament-detail__tournament-podium{
        margin: var(--space) 0;
    }

    .tournament-detail__players__button-options__box{
        width: 326px;
        top: 373px;
        right: 16px;
        margin-right: calc( var(--space) + var(--space-quarter) );
    }

    .tournament-detail__unlocked__info {
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
        margin: 12px;
    }

    .tournament-detail__tournament-team__image {
        width: 28px;
        height: 28px;
    }
    
    .tournament-detail__tournament-team__image .icon-ball {
        font-size: 24px;
        padding: 2px;
    }

    .tournament-detail__tournament-team__image img {
        width: 28px;
        height: 28px;
    }

    .tournament-detail__tournament-team {
        padding: 8px 0;
    }

    .tournament-detail__tournament-teams__title.baloa-subtitle-2 {
        padding-bottom: 8px;
    }

    .tournament-detail__tournament-teams {
        padding: 12px;
        margin: 12px;
    }

    .tournament-detail__tabs__puntuation__container {
        background: transparent;
        padding: 0;
    }

    .tournament-detail__team-players .input-search-with-button__input {
        width: calc(100% - 42px);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/tournament-detail/TournamentDetailComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,sDAAsD;AAC1D;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,sEAAsE,CAAC,SAAS;IAChF,qDAAqD,CAAC,QAAQ;IAC9D,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;;AAEtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;;GAEG;;AAEH;IACI,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,eAAe;;AAEnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;;IAEhB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,wBAAwB;IACxB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;;AAE/B;;AAEA;;IAEI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;;IAEI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,mBAAmB;IACnB,gCAAgC;IAChC,+BAA+B;AACnC;AACA,cAAc;AACd;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,UAAU;AACd;;AAEA;;;IAGI,+CAA+C;IAC/C,oCAAoC;IACpC,yCAAyC;IACzC,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,6CAA6C;IAC7C,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;;GAEG;;AAEH;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,6BAA6B;IAC7B,WAAW;IACX,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wDAAwD;IACxD,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,wDAAwD;IACxD,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,wDAAwD;IACxD,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,0DAA0D;IAC1D,cAAc;IACd,2DAA2D;AAC/D;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,6BAA6B;IAC7B,sEAAsE;IACtE,8CAA8C;IAC9C,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf;sBACkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA,WAAW;AACX;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,uCAAuC;IACvC,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oCAAoC;IACpC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,kDAAkD;IAClD,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;GACG,oBAAoB;AACvB;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,2CAA2C;IAC3C,sCAAsC;IACtC,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,SAAS;QACT,oBAAoB;IACxB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,0BAA0B;QAC1B,WAAW;QACX,aAAa;;IAEjB;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,YAAY;;IAEhB;IACA;QACI,eAAe;QACf,OAAO;QACP,iBAAiB;QACjB,mBAAmB;QACnB,iBAAiB;;IAErB;IACA;QACI,cAAc;QACd,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,QAAQ;QACR,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,eAAe;;IAEnB;IACA;OACG,eAAe;IAClB;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,0CAA0C;QAC1C,aAAa;QACb,kCAAkC;IACtC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,oBAAoB;QACpB,iBAAiB;QACjB,kCAAkC;IACtC;;IAEA;;;QAGI,YAAY;IAChB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,mBAAmB;;IAEvB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,sBAAsB;QACtB,aAAa;QACb,uCAAuC;QACvC,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gCAAgC;QAChC,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,6CAA6C;IACjD;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,qCAAqC;IACzC;;IAEA;QACI,wBAAwB;QACxB,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;IACtC;IACA;QACI,yBAAyB;QACzB,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,MAAM;QACN,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,eAAe;QACf,SAAS;;IAEb;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;QACvB,kCAAkC;IACtC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,WAAW;QACX,yDAAyD;IAC7D;;IAEA;QACI,+CAA+C;QAC/C,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".tournament-detail__container {\n    margin: 0 100px;\n    position: relative;\n}\n\n.tournament-detail__tournament-data {\n    position: relative;\n}\n\n.tournament-detail__title{\n    margin-bottom: 38px;\n    display: flex;\n    align-items: center;\n}\n.tournament-detail__title.baloa-subtitle-2{\n    color: var(--primary-dark-color);\n}\n.tournament-detail__title .icon-arrow-left{\n    padding-right: 16px;\n    font-size: 23px;\n    color: var(--black-color);\n    cursor: pointer;\n}\n.tournament-detail__image{\n    border-radius: 16px 16px 0px 0px;\n    background: rgba(77, 84, 81, 0.64);\n    backdrop-filter: blur(4px);  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n.tournament-detail__image .icon-trophy{\n    color: var(--white-color);\n    font-size: 52px;\n    width: 419px;\n    height: 229px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.tournament-detail__image img{\n    width: 419px;\n    height: 229px;\n}\n.tournament-detail__image__tags{\n    position: absolute;\n    display: flex;\n    bottom: 15px;\n    left: 16px;\n    gap: var(--space-half);\n}\n.tournament-detail__image__tags-tag{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 17px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--white-color);\n    background: rgba(0, 0, 0, 0.61);\n    border-radius: 32px;\n    padding: 5px 8px;\n}\n.tournament-detail__data{\n    padding: 13px 8px 15px 8px;\n    display: flex;\n    align-items: center;\n    background: var(--white-color);\n    justify-content: space-between;\n}\n.tournament-detail__data__info{\n    display: flex;\n    align-items: center;\n}\n.tournament-detail__data__info .icon-ball{\n    color: var(--white-color);\n    font-size: 33px;\n    padding: 5px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-detail__data__info img{\n    width: 43px;\n    height: 43px;\n    border-radius: 50%;\n}\n.tournament-detail__data__info.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-detail__data__button.small{\n    padding: 10px 20px;\n    margin-right: 10px;\n}\n\n.tournament-detail__tabs {\n    background: var(--white-color);\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-detail__tabs .MuiTab-wrapper {\n    text-transform: none;\n    /* New_Table Column Names */\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);/* 15px */\n    line-height: calc(var(--space) + var(--space-eighth));/* 18px*/;\n    letter-spacing: 0.0025em;\n    color: var( --basic-gray-color );\n}\n\n.tournament-detail__tabs .MuiTab-root.Mui-selected *{\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: var( --primary-dark-color );   \n\n}\n\n.tournament-detail__tabs .MuiTab-root:hover .MuiTab-wrapper {\n    color: var( --primary-dark-color );\n}\n\n.tournament-detail__tabs__button{\n    position: absolute;\n    display: flex;\n    bottom: 15px;\n    right: 16px;\n}\n.tournament-detail__tabs__button .secondary-button{\n    padding-left: 13px;\n    color: var(--primary-dark-color);\n}\n.tournament-detail__tabs__button.small{\n    padding: 10px;\n    color: var(--primary-dark-color);    \n}\n\n/* .tournament-detail__tabs__button.small span{\n    grid-area: unset;\n} */\n\n.tournament-detail__tabs__button .icon-share{\n    grid-area: icon;\n    padding-right: 13px;\n    color: var(--new-green-color);\n    font-size: 20px;\n}\n\n.tournament-detail__tabs__button.small:hover{\n    color: var(--white-color);   \n}\n\n.tournament-detail__tabs__button.small:hover .icon-share{\n    color: var(--white-color);   \n}\n.tournament-detail__tournament-teams{\n    margin-top: 14px;\n    padding: 27px 30px;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    border-radius: 14px;\n}\n\n.tournament-detail__tournament-teams .baloa-names {\n    color: var(--new-green-color);\n    text-align: center;\n    cursor: pointer;\n}\n\n.tournament-detail__tournament-teams__title.baloa-subtitle-2{\n    color: var(--primary-dark-color); \n    padding-bottom: 14px;\n}\n.tournament-detail__tournament-team{\n    display: flex;\n    padding: 12px 0;\n\n}\n\n.tournament-detail__tournament-team:hover{\n    cursor: pointer;\n}\n\n.tournament-detail__tournament-team__image{\n    width: 39px;\n    height: 39px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.tournament-detail__tournament-team__image img{\n    width: 39px;\n    height: 39px;\n    border-radius: 50%;\n}\n\n.tournament-detail__tournament-team__image .icon-ball{\n    color: var(--white-color);\n    font-size: 29px;\n    padding: 5px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-detail__tournament-team__data{\n    padding-left: 9px;\n}\n\n.tournament-detail__tournament-team__data .baloa-names, .tournament-detail__tournament-team__data .baloa-username{\n    color: var(--primary-dark-color);\n    text-align: left;\n}\n\n.tournament-detail__selected-team{\n    background: var(--white-color);\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    padding: 12px 27px;\n    margin-top: 14px;\n\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: 0.0025em;\n}\n\n.tournament-detail__selected-team img{\n    border-radius: 50%;\n    width: 38px;\n    height: 38px;\n    margin-right: 27px;\n}\n\n.tournament-detail__selected-team .icon-ball{\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 27px;\n}\n\n.tournament-detail__team-info {\n    display: flex;\n    align-items: center;\n    background-color: var(--white-color);\n    margin-top: var(--space);\n    border-radius: var(--space);\n    margin-right: auto;\n}\n\n.tournament-detail__team-info .hubicon-info {\n    font-size: 20px;\n    border-radius: 50%;\n    background-color: var(--white-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-detail__team-info .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-left: 10px;\n}\n\n.tournament-detail__team-players__team,\n.tournament-detail__team-players__players .player-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-detail__team-players__players {\n    max-height: 314px;\n}\n\n.tournament-detail__team-players__team .left-col,\n.tournament-detail__team-players__players .player-container .left-col {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    \n}\n\n.tournament-detail__team-players__team .left-col .icon-ball,\n.tournament-detail__team-players__players .player-container .left-col .icon-ball {\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    margin-right: var(--space-half);\n}\n\n.tournament-detail__team-container {\n    position: relative;\n}\n\n.tournament-detail__team-players__team .left-col img {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    margin-right: var(--space-half);\n}\n\n.tournament-detail__team-players__team .name-username .baloa-names,\n.tournament-detail__team-players__players .player-container .name-username .baloa-names {\n    white-space: nowrap;\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-detail__team-players__players .player-container .name-username .baloa-names {\n    margin-bottom: var(--space-quarter);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.tournament-detail__team-players__team .name-username .baloa-username,\n.tournament-detail__team-players__players .player-container .name-username .baloa-username {\n    white-space: nowrap;\n    color: var(--primary-dark-color);\n    margin-top: var(--space-eighth);\n}\n/* juagdores */\n.tournament-detail__team-players {  \n    padding: var(--space-and-half);\n    background-color: var(--white-color);\n    border-radius: var(--space);\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n}\n\n.tournament-detail__team-players__players .player-container .right-col {\n    display: flex;\n    justify-content: flex-start;\n    width: 20%;\n}\n\n.tournament-detail__team-players__team .right-col .baloa-username,\n.tournament-detail__team-players__players .player-container .right-col .baloa-username,\n.tournament-detail__team-inscription-column__status.baloa-username {\n    padding: var(--space-quarter) var(--space-half);\n    border-radius: var(--space-and-half);\n    background-color: var(--basic-gray-color);\n    color: var(--white-color) !important;\n    width: fit-content;\n}\n\n.tournament-detail__team-players__team .right-col .baloa-username.enrolled,\n.tournament-detail__team-players__players .player-container .right-col .baloa-username.enrolled, \n.tournament-detail__team-inscription-column__status.baloa-username.enrolled{\n    background-color: var(--new-green-color);\n}\n\n.tournament-detail__team-players__players .player-container .right-col .baloa-username.rejected,\n.tournament-detail__team-inscription-column__status.baloa-username.rejected {\n    background-color: var(--error-color);\n}\n\n.tournament-detail__team-players__players .player-container .right-col .baloa-username.register,\n.tournament-detail__team-inscription-column__status.baloa-username.register {\n    background-color: var(--new-yellow-color);\n}\n\n.players-title.baloa-table-column {\n    color: var(--primary-dark-color);\n    margin: var(--space-and-half) 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-detail__players-title.baloa-hyperlink {\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-and-half);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-detail__players__bottons{\n    display: flex;\n    align-items: center;\n}\n\n.tournament-detail__players__bottons-margin{\n    margin-right: var(--space);\n}\n\n.tournament-detail__team-players__players .left-col img {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    margin-right: var(--space-half);\n}\n\n.tournament-detail__team-rejected-msg {\n    display: flex;\n    align-items: center;\n    background-color: var(--white-color);\n    border-radius: var(--space);\n    margin-top: var(--space);\n}\n\n.tournament-detail__team-rejected-msg span {\n    font-size: var(--space);\n    background-color: var(--error-color);\n    color: var(--white-color);\n    border-radius: 50%;\n    margin-right: var(--space);\n}\n\n.tournament-detail__team-rejected-msg .baloa-table-column {\n    color: var(--primary-very-dark-color);\n}\n\n.enrolled-players.baloa-username {\n    color: var(--basic-gray-color);\n    margin-bottom: var(--space-and-half);\n}\n\n.tournament-detail__player-code {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    background: var(--white-color);\n    border-radius: 14px;\n    padding: 16px;\n    width: 28%;\n    margin-left: 14px;\n}\n\n.tournament-detail__player-code.move-top {\n    top: 64px;\n}\n\n.tournament-detail__player-code .baloa-normal-medium {\n    color: var(--primary-dark-color);\n}\n.tournament-detail__player-code .baloa-normal-medium img {\n    padding-left: 8px;\n}\n\n.tournament-detail__player-code__code {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 23px;\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color);\n    padding: 10px 0;\n    text-align: center;\n    cursor: pointer;\n    background-color: var(--new-background-color);\n    margin-top: 16px;\n}\n.tournament-detail__player-code__code .icon-copy-86{\n    font-size: 20px;\n    color: var(--primary-dark-color);\n}\n\n/* .tournament-detail__team-players__players.scroll {\n    padding-right: var( --space-half );\n} */\n\n.tournament-detail__team-players__team .right-col {\n    margin-right: var( --space-and-half );\n}\n\n.tournament-detail__team-inscription{\n    display: flex;\n    align-items: center;\n    /* justify-content: space-evenly; */\n    flex-wrap: wrap;\n    background: var(--white-color);\n    padding: 12px 16px;\n    border-radius: 16px;\n    width: 70%;\n    margin-top: 12px;\n}\n\n.tournament-detail__team-inscription__data{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n    width: 100%;\n    border: 1px solid var(--new-line-color);\n    border-radius: 16px;\n    margin-top: 16px;\n}\n\n.tournament-detail__team-inscription-column:first-child{\n    width: 40%;\n}\n\n.tournament-detail__team-inscription-column{\n    width: 20%;\n}\n\n.tournament-detail__team-inscription-column__title.first-column{\n    border-top-left-radius: 16px;\n}\n\n.tournament-detail__team-inscription-column__title.last-column{\n    border-top-right-radius: 16px;\n}\n\n.tournament-detail__team-inscription-column__title.baloa-table-column{\n    color: var(--primary-very-dark-color);\n    background-color: var(--new-background-color);\n    padding: 12px 0 12px 16px;\n}\n\n.tournament-detail__team-inscription-column__state.baloa-username{\n    color: var(--basic-gray-color);\n    display: flex;\n    padding: 24px 16px;\n}\n\n.green-bullet{\n    color: var(--new-green-color);\n    font-size: 50px;\n}\n.green-bullet.color{\n    color: var(--error-color);\n}\n\n.tournament-detail__team-inscription-column__button{\n    border: 2px solid var(--new-green-color);\n    background: var(--white-color);\n    padding: 8px 16px;\n    margin: 16px;\n}\n\n.tournament-detail__team-inscription-column__button-player{\n    border: 2px solid var(--new-gray-color);\n    background: var(--white-color);\n    padding: 8px 16px;\n    margin: 16px 0;\n}\n\n.tournament-detail__team-inscription-column__button.baloa-username{\n    color: var(--new-green-color);\n    font-weight: var(--font-medium);\n}\n\n.tournament-detail__team-inscription-column__button.baloa-username:disabled {\n    color: var(--new-green-color);\n    border-color: var(--new-green-color);\n    opacity: 0.6;    \n}\n\n.tournament-detail__team-inscription__title.baloa-hyperlink{\n    color: var(--primary-very-dark-color);\n    width: 100%;\n    padding: 16px 0;\n}\n\n.tournament-detail__team-inscription-column__team-info{\n    display: flex;\n    align-items: center;\n    padding: 12px;\n}\n\n.tournament-detail__team-inscription-column__team-info__name-username{\n    margin-left: 10px;\n}\n\n.tournament-detail__team-inscription-column__team-info__name-username .baloa-names  {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-detail__team-inscription-column__team-info__name-username .baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.tournament-detail__team-inscription-column__team-info img{\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.tournament-detail__team-inscription-column__team-info .icon-ball{\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-detail__team-inscription-column__status{\n    margin: 24px 16px;\n    white-space: nowrap;\n}\n\n.tournament-detail__team-inscription-column__status.team-widget{\n    margin: 0 16px;\n}\n\n\n.tournament-detail__player-inscription{\n    display: flex;\n    width: 100%;\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n}\n\n.tournament-detail__player-inscription-column__title.baloa-table-column{\n    color: var(--primary-very-dark-color);\n    background-color: var(--new-background-color);\n    padding: 12px 0 12px 16px;\n}\n\n.tournament-detail__player-inscription-column__title:first-child{\n    width: 33%;\n    border-top-left-radius: 16px;\n}\n\n.tournament-detail__player-inscription-column__title:last-child{\n    border-top-right-radius: 16px;\n}\n\n.tournament-detail__player-inscription-column__title{\n    width: 22%;\n}\n\n.tournament-detail__player-inscription-column{\n    width: 22%;\n    display: flex;\n    align-items: center;\n    padding: 0 0 0 16px;\n}\n\n.staff__roll{\n    justify-content: center;\n}\n\n.tournament-detail__player-inscription-column:first-child{\n    width: 34%;\n}\n\n.tournament-detail__player-inscription-column .baloa-username{\n    align-items: center;\n    display: flex;\n    color: var(--primary-dark-color);\n}\n\n.tournament-detail__player-inscription-column .baloa-username.disabled {\n    color: var(--primary-color);\n}\n\n.tournament-detail__player-inscription-column img {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    margin-right: 12px;\n}\n\n.tournament-detail__player-inscription-column .icon-ball{\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 12px;\n}\n.margin_form{\n    margin-top: var(--space-and-half);\n    margin-bottom: var(--space);\n}\n\n.tournament-detail__player-code__quantity.baloa-username{\n    padding-top: 12px;\n    color: var(--basic-gray-color);\n    font-weight: bold;\n}\n\n.tournament-detail__player-code__quantity-text{\n    font-weight: normal;\n}\n.tournament-detail__image__background-img_container {\n    position: absolute;\n    width: 100%;\n    height: 229px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 16px 16px 0px 0px;\n}\n\n.tournament-detail__image__background-img {\n    width: 100%;\n}\n\n.tournament-detail__team-inscription .secondary-button {\n    border: var( --space-eighth ) solid var( --error-color );\n    color: var( --error-color );\n    margin-top: 16px;\n}\n\n.tournament-detail__team-inscription .secondary-button:hover {\n    border: var( --space-eighth ) solid var( --error-color );\n    color: var( --white-color );\n    background-color: var(--error-color);\n}\n\n.tournament-detail__team-inscription .secondary-button:focus {\n    border: var( --space-eighth ) solid var( --error-color );\n    color: var( --white-color );\n    background-color: var(--error-color);\n}\n\n.tournament-detail__team-inscription_mobile{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n    background: var(--white-color);\n    padding: 12px 12px;\n    border-radius: 16px;\n    width: 100%;\n    margin-top: 12px;\n}\n\n.tournament-detail__team-inscription-team_inf{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.tournament-detail__player-inscription-row_mobile{\n    display: flex;\n    justify-content: space-between;\n    width:85%;\n}\n\n.tournament-detail__player-inscription-buttons_mobile{\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-detail__player-inscription-buttons_text_mobile{\n    margin-right: var(--space-x2);\n}\n\n.tournament-detail__player-inscription-buttons_text_mobile .baloa-username{\n    display: flex;\n}\n\n.tournament-detail__team-inscription_buttons_form{\n    display: flex;\n    justify-content: space-between;\n    width: 70%;\n}\n\n.tournament-detail__player-code_mobile {\n    background: var(--white-color);\n    border-radius: 14px;\n    padding: 16px;\n    margin: var(--space) 0;\n}\n\n.tournament-detail_search_player-form {\n    display: flex;\n    align-items: center;\n    padding-bottom: var(--space);\n}\n\n.tournament-detail_search_player-form span.icon-search {\n    position: absolute;\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n    color: #949F9A;\n    margin-left: calc( var( --space ) - var( --space-eighth ) );\n}\n\n.tournament-detail_search_input {\n    min-width: calc(var(--space-x3) * 8);\n    border: none;\n    min-height: var( --space-x2 );\n    border-radius: calc( var( --space-and-half ) - var( --space-eighth ) );\n    background: var( --new-gray-background-color );\n    padding-left: var( --space-x3 );\n}\n\n.tournament-detail__team-players_mobile{\n    padding: var(--space-and-half);\n    background-color: var(--white-color);\n    border-radius: var(--space);\n    margin-top: var(--space);\n    margin-bottom: var(--space-x3);\n}\n\n.tournament-detail__team-container .tournament-detail__team-players .tournament-detail__teams-filter {\n    margin-bottom: var(--space);\n    margin-top: var(--space);\n}\n\n.tournament-detail__team-container .tournament-detail__team-players_mobile .tournament-detail__teams-filter {\n    margin-bottom: var(--space);\n}\n\n.tournament-detail__team-players__share-button .hubicon-person_add {\n    grid-area: icon;\n    margin-right: 13px;\n    font-size: 24px;\n}\n\n.secondary-button.tournament-detail__team-players__share-button{\n    padding: 10px 20px;\n}\n\n.tournament-detail__data__button span.hubicon-manage_accounts1 {\n    grid-area: icon;\n    /* color: var(--primary-very-dark-color);\n    font-size: 20px; */\n    justify-self: end;\n    margin-right: 4px;\n}\n\n.tournament-detail__data_buttons{\n    display: flex;\n    gap: var(--space); \n}\n\n.tournament-detail_data_buttons_icons{\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    gap: 10px;\n}\n\n.tournament-detail__staff {  \n    padding: var(--space-and-half);\n    background-color: var(--white-color);\n    border-radius: var(--space);\n    margin-top: var(--space);\n    margin-bottom: var(--space-x3);\n}\n\n.tournament-detail__staff-title{\n    margin-bottom: var(--space);\n}\n\n.tournament-detail__staff-inscription{\n    display: flex;\n    width: 100%;\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n}\n\n.tournament-detail__staff-inscription-column__title.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    background-color: var(--new-background-color);\n    padding: 12px 0 12px 16px;\n}\n\n.tournament-detail__staff-inscription-column__title:first-child{\n    width: 33%;\n    border-top-left-radius: 16px;\n}\n\n.tournament-detail__staff-inscription-column__title:last-child{\n    border-top-right-radius: 16px;\n}\n\n.tournament-detail__staff-inscription-column__title{\n    width: 22%;\n}\n.tournament-detail__staff-inscription-column__title__width{\n    width: 11%;\n}\n\n/**Mobile**/\n.tournament-detail__team-inscription-column-mobile:first-child{\n    width: 70%;\n}\n.tournament-detail__team-inscription-column-mobile{\n    width: 30%;\n}\n.tournament-detail__team-inscription_buttons_form .tournament-detail__team-inscription-column-mobile{\n    width: 50%;\n    padding: 0 12px;\n}\n\n.tournament-detail__team-inscription-column__button-mobile.baloa-username{\n    border: 2px solid var(--new-green-color);\n    background: var(--white-color);\n    padding: 8px 16px;\n    margin: 12px 0;\n}\n\n.tournament-detail__no-dates-phases__container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin-top: 100px;\n}\n\n.tournament-detail__container .league-tournament-report-dates__tabs,\n.tournament-detail__phases__list {\n    background-color: var(--white-color);\n}\n\n.tournament-detail__phases__list .MuiFormControl-root {\n    min-width: 350px;\n    margin: 16px 16px 24px 16px;\n    border: 1px solid var(--new-gray-color);\n    padding: var(--space-half-quarter);\n    border-radius: var(--space-quarter);\n}\n\n.tournament-detail__phases__list .MuiInputBase-root {\n    font-family: var(--secondary-font);\n    font-weight: var(--font-medium);\n    font-size: 19px;\n    line-height: 22px;\n}\n\n.tournament-detail__phases__list .MuiInput-underline:before, \n.tournament-detail__phases__list .MuiInput-underline:hover:not(.Mui-disabled):before,\n.league-tournament-report-calendar__tabs_border .MuiTabs-flexContainer {\n    border-bottom: none;\n}\n\n.tournament-detail__responsive__inscription-btn {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    background-color: var(--white-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: var(--space);\n    z-index: 100;\n}\n\n.tournament-detail__responsive__inscription-btn .tournament-detail__data__button.small {\n    margin: 0px;\n    padding: none;\n    width: 100%;\n}\n\n.tournament-hub__loader-mobile {\n    height: 100vh;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-hub__loader-mobile img {\n    width: 40%;\n}\n\n.league-tournament-report-tab-options_iframe{\n    display: flex;\n    justify-content: space-between;\n    background-color: var(--white-color);\n    align-items: center;\n    padding-right: var(--space);\n}\n\n.tournament-detail__tournament-podium{\n    margin: var(--space-x2) 0;\n}\n\n.tournament-detail__players-title{\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    cursor: pointer;\n}\n\n.tournament-detail__players__button-options__box{\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    width: 300px;\n    right: 0;\n    top: 50px;\n    display: none;   \n    border-radius: var(--space-half); \n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space-half);\n}\n\n.tournament-detail__players__button-options__box.active{\n    display: block;\n    z-index: 1;\n}\n\n.tournament-detail__button-options__box__box-option {\n    cursor: pointer;\n    border-radius: 8px;\n    padding: var(--space-half);\n}\n.tournament-detail__button-options__box__box-option:hover {\n    background-color: var(--new-background-color);\n}\n\n.tournament-detail__button-options__box__box-option .baloa-names,\n.tournament-detail__button-options__box__box-option .baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-detail__unlocked__info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 4px;\n    padding: 8px;\n    gap: 8px;\n    background: var(--white-color);\n    margin-top: 12px;\n}\n\n.tournament-detail__unlocked__team-info {\n    display: flex;\n    align-items: center;\n    background-color: var(--white-color);    \n}\n\n.tournament-detail__unlocked__team-info .hubicon-info:before {\n    font-size: 20px;\n    color: var(--new-informative-banner-color);\n}\n\n.tournament-detail__unlocked__team-info .hubicon-award_star {\n    font-size: 20px;\n}\n\n.tournament-detail__unlocked__team-info .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-left: 10px;\n}\n\n.tournament-detail__unlocked__info .button.small{\n    padding: 8px 12px;\n}\n\n.league-tournament-report-calendar__tabs_border{\n    border-bottom: 2px solid var(--border-card-color);\n    background-color: white;\n}\n\n.league-tournament-report-calendar__tabs_border .PrivateTabIndicator-colorPrimary-2, .league-tournament-report-calendar__tabs .MuiTab-wrapper{\n    background-color: white; \n}\n\n.league-tournament-report-calendar__tabs{\n    background-color: white;\n    border-bottom: none;\n}\n\n.league-tournament-report-calendar__tab{\n   padding-bottom: 12px;\n}\n\n.league-tournament-report-calendar__tab .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary {\n    border: 1px solid var(--basic-gray-color);\n    border-radius: 25px;\n    background: var(--white-color);\n    padding: 6px 12px;\n    min-height: unset;\n    margin: 0 5px;\n}\n\n.league-tournament-report-calendar__tab .MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected {\n    border: 1px solid var(--new-green-color);\n    background: #EAF7F0;\n}\n\n.league-tournament-report-calendar__tabs .Mui-selected .MuiTab-wrapper,.league-tournament-report-calendar__tabs_border .Mui-selected .MuiTab-wrapper {\n    border: 2px solid var(--new-green-color);\n    background-color: #EAF7F0;\n}\n\n.tournament-detail__team-players__players-skeleton {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 12px 16px;\n}\n\n.tournament-detail__team-players__players-skeleton__text {\n    margin-left: 10px;\n}\n\n.tournament-detail__team-players__players-skeleton__last-text {\n    align-items: center;\n    margin-left: auto;\n    margin-right: 12%;\n}\n\n.tournament-detail__team-players__players__view-more-link.baloa-names {\n    color: var(--new-green-color);\n    text-align: center;\n    cursor: pointer;\n    position: sticky;\n    bottom: -1px;\n    background: var(--white-color);\n}\n\n.tournament-detail__team-players__players__empty-msg.baloa-names {\n    padding: 80px 0;\n    text-align: center;\n    color: var(--basic-gray-color);\n}\n\n.tournament-detail__teams-filter {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-detail__teams-filter .filter-label.baloa-table-column {\n    color: var( --primary-dark-color );\n    margin-right: var( --space-half );\n    padding: var( --space-half ) var( --space );\n    border-radius: var( --space-and-half );\n    border: 1px solid var( --primary-dark-color );\n    cursor: pointer;\n}\n\n.tournament-detail__teams-filter .filter-label.baloa-table-column.selected-state {\n    color: var( --new-green-color );\n    background-color: #EAF7F0;\n    border: 1px solid var( --new-green-color );\n}\n\n.tournament-detail__staff-info-inscription-column:first-child{\n    width: 70%;\n}\n\n.tournament-detail__staff-info-inscription-column{\n    width: 30%;\n}\n\n.tournament-detail__staff-info-inscription-column__title.first-column{\n    border-top-left-radius: 16px;\n}\n\n.tournament-detail__staff-info-inscription-column__title.last-column{\n    border-top-right-radius: 16px;\n}\n\n.tournament-detail__staff-info-inscription-column__title.baloa-table-column{\n    color: var(--primary-very-dark-color);\n    background-color: var(--new-background-color);\n    padding: 12px 0 12px 16px;\n}\n\n.tournament-detail__staff-info-inscription-column__state.baloa-username {\n    color: var(--basic-gray-color);\n    display: flex;\n    padding: 24px 16px;\n}\n\n#menu-teamname .MuiPaper-root.MuiPopover-paper.MuiMenu-paper {\n    top: 10px !important;\n}\n\n.tournament-detail__tabs__puntuation__container {\n    background: var(--white-color);\n    padding: 20px;\n}\n\n.tournament-detail__payment-message__container {\n    background: var(--white-color);\n    border-radius: 8px;\n    padding: 8px;\n    margin-top: 12px;\n}\n\n.tournament-detail__payment-message {\n    background: var(--new-informative-banner-bg-color);\n    border-radius: 8px;\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    justify-content: space-between;\n}\n\n.tournament-detail__payment-message .button {\n    padding: 8px 12px;\n}\n\n.tournament-detail__payment-message .button span {\n    white-space: nowrap;\n}\n\n.tournament-detail__payment-message__data .baloa-names {\n    font-size: calc(var(--space) + 2px);\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    margin-top: 8px;\n}\n\n.tournament-detail__payment-message__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 4px;\n}\n\n.tournament-detail__payment-message__title .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-detail__payment-message__title .hubicon-info::before {\n    font-size: 21px;\n    color: var(--new-informative-banner-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .tournament-detail__container{\n        margin: 0;\n        padding-bottom: 50px;\n    }\n    .tournament-detail__title.baloa-subtitle-2 {\n        margin: 0 0 20px 16px;\n    }\n    .tournament-detail__image img{\n        border-radius: 5px 5px 0 0;\n        width: 100%;\n        height: 205px;\n        \n    }\n    .tournament-detail__image__tags{\n        /* font-size: 10px; */\n        width: 42px;\n        height: 12px;\n        \n    }\n    .tournament-detail__image__tags-tag{\n        font-size: 10px;\n        top:4px;\n        line-height: 12px;\n        white-space: nowrap;\n        margin-right: 5px;\n        \n    }\n    .tournament-detail__data{\n        display: block;\n        background: var(--white-color);\n    }\n    .tournament-detail__data__info img{\n        width: 28px;\n        height: 28px;\n        left: 12px;\n        top:12px;\n        border-radius: 50%;\n    }\n    .tournament-detail__data__info.baloa-subtitle-2{\n        font-size: 15px;\n        white-space: nowrap;\n    }\n    .tournament-detail__data__button.small{\n        padding: 8px 12px;\n        margin-right: 0;\n        \n    }\n    .tournament-detail__data__button span{\n       font-size: 12px;\n    }\n    .tournament-detail__tabs.MuiTabs-root{\n        border-top: none;\n        min-height: 28px;\n    }\n\n    .tournament-detail__tabs .MuiTabs-indicator {\n        bottom: auto ;\n        width: 63px;\n        height: 4px;\n        border-radius: 4px 4px 0px 0px;  \n    }\n\n    .tournament-detail__container .MuiTabs-flexContainer {\n        display: block;\n        border-bottom:0;            \n    }\n\n    .tournament-detail__tabs .MuiTab-fullWidth{\n        white-space: nowrap;\n        padding: var(--space-quarter) var(--space);\n        min-height: 0;\n        font-family: var(--secondary-font);\n    }\n\n    .tournament-information span{\n        color:var(--basic-gray-color);\n    }\n\n    .tournament-detail__team-players__team, .tournament-detail__team-players__players .player-container{\n        flex-direction: column;\n        align-items: flex-start;\n        padding-bottom: 10px;\n        padding-top: 10px;\n        border-bottom: 0.5px solid #E7E7E7;\n    }\n\n    .tournament-detail__player-inscription-column,\n    .tournament-detail__team-inscription__title.baloa-hyperlink \n    /* .tournament-detail__team-inscription-column__team-info */{\n        padding: 0px;\n    }\n\n    .tournament-detail__team-inscription-column__button-player,\n    .tournament-detail__data_share_mobile .tournament-detail__tabs__button{\n        margin: 0px;\n    }\n\n    .tournament-detail__player-inscription-row_mobile .tournament-detail__player-inscription-column .tournament-detail__team-inscription-column__status{\n        margin: 14px;\n        white-space: nowrap;\n\n    }\n\n    .tournament-detail__team-inscription__data{\n        border: none;\n        border-radius:0px;\n        flex-direction: column;\n        margin-top: 0;\n        border: 1px solid var(--new-line-color);\n        border-radius: 16px;\n        margin-top: 12px;\n    }\n\n    .tournament-detail__team-inscription-column{\n        width: auto;\n    }\n\n    .tournament-detail__team-inscription-column__state.baloa-username{\n        padding: 16px 0;\n    }\n\n    .tournament-detail_search_input.baloa-names{\n        font-weight: var(--font-regular);\n        font-size: 13px;\n        color:var(--basic-gray-color);\n    }\n\n    .tournament-detail__team-players_mobile .tournament-detail__team-players__players .player-container{\n        flex-direction: row;\n    }\n\n    .tournament-detail__team-inscription-column__title.baloa-table-column{\n        background-color: var(--new-background-color);\n    }\n\n    .tournament-detail__data_share_mobile{\n        display: flex;\n        justify-content: space-between;\n        margin-top: var(--space);\n    }\n\n    .tournament-detail__data_share_mobile .hubicon-share {\n        font-size: var(--space-x2);\n        margin-right: var(--space);\n    }    \n    .tournament-detail_search_input {\n        min-width: unset;\n        width: 100%;\n    }\n    \n    .players-title.baloa-table-column{\n        display: block;\n        margin-top:0;\n        color: var(--primary-very-dark-color);\n    }\n\n    .primary-button.tournament-detail__team-players__share-button{\n        margin-top: var(--space);\n        width: 100%;\n        justify-content: center;\n    }\n\n    .tournament-detail__team-players__share-button .icon {\n        grid-area: icon;\n    }\n\n    .tournament-detail__team-players__share-button .hubicon-share_v2{\n        color: var(--white-color);\n    }\n\n    .tournament-detail__player-inscription-buttons_text_mobile,\n    .tournament-detail__player-inscription-buttons_text_mobile .baloa-name{\n        margin-top: var(--space);\n    }\n\n    .tournament-detail__player-inscription-buttons_text_mobile .baloa-username{\n        margin-top: var(--space-half);\n        padding-top: var(--space-half);\n    }\n\n    .tournament-detail__team-players {\n        padding-top: var(--space-and-half);\n    }\n    .tournament-detail__team-inscription-column__team-info .icon-ball{\n        color: var(--white-color);\n        font-size: 24px;\n        padding: 2px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .tournament-detail__team-inscription-column__team-info img {\n        width: 28px;\n        height: 28px;\n        border-radius: 50%;\n    }\n\n    .tournament-detail__data_buttons {\n        gap: 0;\n        justify-content: center;\n        margin-top: var(--space-and-half);\n    }\n\n    .tournament-detail__phases__list .MuiFormControl-root {\n        min-width: 100%;\n        margin: 0;\n        \n    }\n\n    .tournament-detail__phases__list {\n        padding: var(--space);\n    }\n\n    .tournament-detail__phases__list .MuiInputBase-root {\n        font-size: var(--space);\n        line-height: var(--space-and-half);\n    }\n\n    .tournament-detail__tournament-podium{\n        margin: var(--space) 0;\n    }\n\n    .tournament-detail__players__button-options__box{\n        width: 326px;\n        top: 373px;\n        right: 16px;\n        margin-right: calc( var(--space) + var(--space-quarter) );\n    }\n\n    .tournament-detail__unlocked__info {\n        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);\n        margin: 12px;\n    }\n\n    .tournament-detail__tournament-team__image {\n        width: 28px;\n        height: 28px;\n    }\n    \n    .tournament-detail__tournament-team__image .icon-ball {\n        font-size: 24px;\n        padding: 2px;\n    }\n\n    .tournament-detail__tournament-team__image img {\n        width: 28px;\n        height: 28px;\n    }\n\n    .tournament-detail__tournament-team {\n        padding: 8px 0;\n    }\n\n    .tournament-detail__tournament-teams__title.baloa-subtitle-2 {\n        padding-bottom: 8px;\n    }\n\n    .tournament-detail__tournament-teams {\n        padding: 12px;\n        margin: 12px;\n    }\n\n    .tournament-detail__tabs__puntuation__container {\n        background: transparent;\n        padding: 0;\n    }\n\n    .tournament-detail__team-players .input-search-with-button__input {\n        width: calc(100% - 42px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
